module.exports = __webpack_public_path__ + "static/media/learningamazing.868a77dc.png";